import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

const routes = [{
    path: "/login",
    name: "login",
    component: () =>
        import("../views/Login.vue"),
},
{
    path: "/Home",
    name: "Home",
    component: () =>
        import("../views/admin/Home.vue"),
    redirect: "/menu",
    children: [{
        path: "/menu",
        component: () =>
            import("../views/admin/menu.vue"),
    },
    {
        path: "/user",
        component: () =>
            import("../views/admin/user/index.vue"),
    },
    {
        path: "/log",
        component: () =>
            import("../views/admin/log/index.vue"),
    },
    {
        path: "/role",
        component: () =>
            import("../views/admin/position/index.vue"),
    },
    {
        path: "/archive",
        component: () =>
            import("../views/admin/archive/index.vue"),
    },
    {
        path: "/problem",
        component: () =>
            import("../views/admin/problem/index.vue"),
    },
    {
        path: "/userapp",
        component: () =>
            import("../views/admin/applets/index.vue"),
    },
    {
        path: "/merchant",
        component: () =>
            import("../views/admin/merchant/index.vue"),
    },
    {
        path: "/scenicspot",
        component: () =>
            import("../views/admin/scenicspot/index.vue"),
    },
    {
        path: "/rollup",
        component: () =>
            import("../views/admin/roll/index.vue"),
    },
    {
        path: "/activitie",
        component: () =>
            import("../views/admin/activity/index.vue"),
    },
    {
        path: "/product",
        component: () =>
            import("../views/admin/product/index.vue"),
    },
    {
        path: "/productType",
        component: () =>
            import("../views/admin/product/type/index.vue"),
    },
    {
        path: "/digit",
        component: () =>
            import("../views/admin/digit/index.vue"),
    },
    {
        path: "/zhongyang",
        component: () =>
            import("../views/admin/zhongyang/index.vue"),
    },
    {
        path: "/merchantType",
        component: () =>
            import("../views/admin/merchant/type/index.vue"),
    },
    {
        path: "/rollType",
        component: () =>
            import("../views/admin/roll/type/index.vue"),
    },
    {
        path: "/order",
        component: () =>
            import("../views/admin/order/index.vue"),
    },
    {
        path: "/parameter",
        component: () =>
            import("../views/admin/parameter/index.vue"),
    },
    {
        path: "/banner",
        component: () =>
            import("../views/admin/banner/index.vue"),
    },
    {
        path: "/message",
        component: () =>
            import("../views/admin/message/index.vue"),
    }
    ],
},
];

const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes,
});
router.beforeEach((to, from, next) => {
    const tokenStr = sessionStorage.getItem("token");
    if (to.path === "/login") next();
    if (to.path === "/") {
        sessionStorage.clear();
        return next("/login");
    }
    if (!tokenStr && to.path !== "/login") {
        sessionStorage.clear();
        return next("/login");
    }
    next();
});

export default router;